import ControlLabel from './ControlLabel';
export default ControlLabel;